<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Biochemical Tests
        </h2>

        <div class="">
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Biochemical test results
            </h3>

            <p class=" font-light italic">Initial testing</p>

            <ul class="list-disc pl-4  font-light">
                <li>
                    The patient’s laboratory tests showed:
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>Severe anemia</li>
                        <li>Metabolic acidosis</li>
                        <li>Markedly increased serum BUN and SCr levels</li>
                        <li>High phosphorus, magnesium, and PTH levels</li>
                    </ul>
                </li>
            </ul>
        </div>

        <div>
            <p class=" font-light italic">Additional testing</p>

            <ul class="list-disc pl-4  font-light">
                <li>
                    After ultrasound and CT scans, ESKD with a left kidney stone was diagnosed and PH1 was suspected as the underlying pathogenesis
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>Workup showed <span class="font-semibold">high serum oxalate</span> of 88 µmol/L (normal: &lt;5 µmol/L) and low urinary oxalate of  0.04 mmol/24 hours (normal: 0.14–0.42 mmol/24 hours)</li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
